import { Card as CardAntd, Row as RowAntd } from 'antd';
import styled from 'styled-components';

export const Card = styled(CardAntd)`
  .ant-card-body {
    padding-top: 0;
  }

  .height-85 {
    height: 85vh;
  }

  .margin-sides {
    margin: 0 8px;
  }
`;

export const Footer = styled(RowAntd)`
  margin-top: 10px;
  margin-left: 0px !important;
  margin-right: 0px !important;
`;
